module.exports = __webpack_public_path__ + "img/head.557f953c.png";